export const GRADE_SCALE_MAX = 100;
